module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": _vm.id
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9eb82102!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/paypalButton.vue
// module id = 520
// module chunks = 1